/**
 * HLM custom. See CUSTOMIZATIONS.md
 * Bundle add-ons: each row has an Add button that adds only that variant to cart.
 * Separate asset so vendor theme.js is not modified on theme updates.
 */
if (!customElements.get('product-addon-bundles')) {
  customElements.define(
    'product-addon-bundles',
    class ProductAddonBundles extends HTMLElement {
      connectedCallback() {
        this.cartDrawerElement = document.querySelector('cart-drawer');
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      showError(message = false) {
        const box = this.querySelector('[data-bundle-addon-error]');
        if (!box) {
          if (message) window.alert(message);
          return;
        }
        box.hidden = !message;
        if (message) box.textContent = message;
      }

      toggleButtonLoading(button, loading) {
        if (!button) return;
        button.classList.toggle('btn--loading', loading);
        if (loading) {
          button.setAttribute('aria-disabled', 'true');
        } else if (!button.hasAttribute('disabled')) {
          button.removeAttribute('aria-disabled');
        }
      }

      onClick = (event) => {
        if (typeof FoxTheme === 'undefined' || !FoxTheme.utils) return;

        const button = event.target.closest('[data-bundle-addon-add]');
        if (!button || button.disabled || button.classList.contains('btn--loading')) return;

        event.preventDefault();
        this.showError(false);

        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;

        const items = [{ id: variantId, quantity: 1 }];

        if (
          document.body.classList.contains('cart-template') ||
          FoxTheme.settings.cartType !== 'drawer'
        ) {
          FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, {
            parameters: { items },
          });
          return;
        }

        this.toggleButtonLoading(button, true);

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } }),
        );

        const body = JSON.stringify({
          items,
          sections: sectionsToBundle,
          sections_url: window.location.pathname,
        });

        fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.showError(parsedState.description || parsedState.message);
              return;
            }

            const cartJson = await (
              await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })
            ).json();
            cartJson.sections = parsedState.sections;

            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            document.dispatchEvent(
              new CustomEvent('product-ajax:added', {
                bubbles: true,
                detail: { product: parsedState },
              }),
            );
            this.cartDrawerElement?.show(button);
          })
          .catch((e) => {
            console.error(e);
            this.showError('Unable to add to cart.');
          })
          .finally(() => {
            this.toggleButtonLoading(button, false);
          });
      };
    },
  );
}
